import { ADD_PERMISSION, CLEAR_PERMISSION, IAuth } from '../actions/auth';
const initialStateAuth: IAuth = {
  authToken: '',
  expiresOn: undefined,
  loggedIn: false,
  permissions: [],
  hasWriteAccess: false,
} as unknown as IAuth;

export default function permissionReducer(
  state = initialStateAuth,
  action: { type: string; authValues?: IAuth }
): object {
  switch (action.type) {
    case ADD_PERMISSION:
      return { ...state, ...action.authValues };

    case CLEAR_PERMISSION:
      return initialStateAuth;

    default:
      return state;
  }
}
